/* tslint:disable */
/**
* Kronos Api
* No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
*
* OpenAPI spec version: v1
* 
*
* NOTE: This class is auto generated by the swagger code generator program.
* https://github.com/swagger-api/swagger-codegen.git
* Do not edit the class manually.
*/


import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AnlagenSearchDtoSearchResponse } from '../model/anlagenSearchDtoSearchResponse';
import { BillActivityExportDto } from '../model/billActivityExportDto';
import { BillAnlagenSearchRequestDto } from '../model/billAnlagenSearchRequestDto';
import { BillApprovalDto } from '../model/billApprovalDto';
import { BillCostCentreSearchRequestDto } from '../model/billCostCentreSearchRequestDto';
import { BillCreditorUpdateDto } from '../model/billCreditorUpdateDto';
import { BillCustomerSearchRequestDto } from '../model/billCustomerSearchRequestDto';
import { BillDetailBootstrapDto } from '../model/billDetailBootstrapDto';
import { BillDetailLayoutCollectionDto } from '../model/billDetailLayoutCollectionDto';
import { BillDetailLayoutCollectionUpdateDto } from '../model/billDetailLayoutCollectionUpdateDto';
import { BillDocumentDto } from '../model/billDocumentDto';
import { BillDocumentUploadLinkDto } from '../model/billDocumentUploadLinkDto';
import { BillDocumentsDto } from '../model/billDocumentsDto';
import { BillDto } from '../model/billDto';
import { BillFibuAccountSearchRequestDto } from '../model/billFibuAccountSearchRequestDto';
import { BillFilterDto } from '../model/billFilterDto';
import { BillFilterReorderDto } from '../model/billFilterReorderDto';
import { BillHeadUpdateDto } from '../model/billHeadUpdateDto';
import { BillHistoryDto } from '../model/billHistoryDto';
import { BillOverviewGridStateDto } from '../model/billOverviewGridStateDto';
import { BillPositionDto } from '../model/billPositionDto';
import { BillPositionGridStateDto } from '../model/billPositionGridStateDto';
import { BillPositionGridType } from '../model/billPositionGridType';
import { BillPositionReorderDto } from '../model/billPositionReorderDto';
import { BillPositionUpsertDto } from '../model/billPositionUpsertDto';
import { BillPositionsReplaceDto } from '../model/billPositionsReplaceDto';
import { BillPositionsValidationDto } from '../model/billPositionsValidationDto';
import { BillProcessTypeUpdateDto } from '../model/billProcessTypeUpdateDto';
import { BillProjectSearchRequestDto } from '../model/billProjectSearchRequestDto';
import { BillPurchaseOrderItemsDto } from '../model/billPurchaseOrderItemsDto';
import { BillPurchaseOrderSearchRequestDto } from '../model/billPurchaseOrderSearchRequestDto';
import { BillReassignDto } from '../model/billReassignDto';
import { BillSearchRequestDto } from '../model/billSearchRequestDto';
import { BillSearchResponseDto } from '../model/billSearchResponseDto';
import { CostCentreSearchDtoSearchResponse } from '../model/costCentreSearchDtoSearchResponse';
import { CreateBillDocumentDto } from '../model/createBillDocumentDto';
import { CreateBillDocumentUploadLinkDto } from '../model/createBillDocumentUploadLinkDto';
import { CreateBillFilterRequestDto } from '../model/createBillFilterRequestDto';
import { CustomerSearchDtoSearchResponse } from '../model/customerSearchDtoSearchResponse';
import { FibuAccountSearchDtoSearchResponse } from '../model/fibuAccountSearchDtoSearchResponse';
import { PaymentTermDto } from '../model/paymentTermDto';
import { ProjectSearchDtoSearchResponse } from '../model/projectSearchDtoSearchResponse';
import { PurchaseOrderItemDto } from '../model/purchaseOrderItemDto';
import { PurchaseOrderOverviewDtoSearchResponse } from '../model/purchaseOrderOverviewDtoSearchResponse';
import { SupplierSearchDtoSearchResponse } from '../model/supplierSearchDtoSearchResponse';
import { SupplierSearchRequestDto } from '../model/supplierSearchRequestDto';
import { UpdateBillFilterRequestDto } from '../model/updateBillFilterRequestDto';
import { UpdateBillPositionGridStateDto } from '../model/updateBillPositionGridStateDto';
import { UpdateBillPurchaseOrderPositionsDto } from '../model/updateBillPurchaseOrderPositionsDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BillService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addDocument(id: string, body?: CreateBillDocumentDto, observe?: 'body', reportProgress?: boolean): Promise<BillDocumentDto>;
    public addDocument(id: string, body?: CreateBillDocumentDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDocumentDto>>;
    public addDocument(id: string, body?: CreateBillDocumentDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDocumentDto>>;
    public addDocument(id: string, body?: CreateBillDocumentDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling addDocument.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/documents`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applyPurchaseOrderPositions(id: string, body?: UpdateBillPurchaseOrderPositionsDto, observe?: 'body', reportProgress?: boolean): Promise<BillDto>;
    public applyPurchaseOrderPositions(id: string, body?: UpdateBillPurchaseOrderPositionsDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDto>>;
    public applyPurchaseOrderPositions(id: string, body?: UpdateBillPurchaseOrderPositionsDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDto>>;
    public applyPurchaseOrderPositions(id: string, body?: UpdateBillPurchaseOrderPositionsDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling applyPurchaseOrderPositions.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/positions/from-purchase-order`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public approve(id: string, observe?: 'body', reportProgress?: boolean): Promise<BillApprovalDto>;
    public approve(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillApprovalDto>>;
    public approve(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillApprovalDto>>;
    public approve(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling approve.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/approve`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param messageId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public archiveChatMessageDocuments(id: string, messageId: number, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public archiveChatMessageDocuments(id: string, messageId: number, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public archiveChatMessageDocuments(id: string, messageId: number, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public archiveChatMessageDocuments(id: string, messageId: number, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling archiveChatMessageDocuments.');
        }
        if (messageId === null || messageId === undefined) {
            throw new Error('Required parameter messageId was null or undefined when calling archiveChatMessageDocuments.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/documents/chat-messages/${encodeURIComponent(String(messageId))}/archive`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public completeAccounting(id: string, observe?: 'body', reportProgress?: boolean): Promise<BillApprovalDto>;
    public completeAccounting(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillApprovalDto>>;
    public completeAccounting(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillApprovalDto>>;
    public completeAccounting(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling completeAccounting.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/complete-accounting`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createAdditionalCost(id: string, body?: BillPositionUpsertDto, observe?: 'body', reportProgress?: boolean): Promise<BillPositionDto>;
    public createAdditionalCost(id: string, body?: BillPositionUpsertDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillPositionDto>>;
    public createAdditionalCost(id: string, body?: BillPositionUpsertDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillPositionDto>>;
    public createAdditionalCost(id: string, body?: BillPositionUpsertDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling createAdditionalCost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/positions/additional-costs`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createDocumentUploadLink(id: string, body?: CreateBillDocumentUploadLinkDto, observe?: 'body', reportProgress?: boolean): Promise<BillDocumentUploadLinkDto>;
    public createDocumentUploadLink(id: string, body?: CreateBillDocumentUploadLinkDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDocumentUploadLinkDto>>;
    public createDocumentUploadLink(id: string, body?: CreateBillDocumentUploadLinkDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDocumentUploadLinkDto>>;
    public createDocumentUploadLink(id: string, body?: CreateBillDocumentUploadLinkDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling createDocumentUploadLink.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/documents/upload-link`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createFilter(body?: CreateBillFilterRequestDto, observe?: 'body', reportProgress?: boolean): Promise<BillFilterDto>;
    public createFilter(body?: CreateBillFilterRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillFilterDto>>;
    public createFilter(body?: CreateBillFilterRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillFilterDto>>;
    public createFilter(body?: CreateBillFilterRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/filters`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createPosition(id: string, body?: BillPositionUpsertDto, observe?: 'body', reportProgress?: boolean): Promise<BillPositionDto>;
    public createPosition(id: string, body?: BillPositionUpsertDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillPositionDto>>;
    public createPosition(id: string, body?: BillPositionUpsertDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillPositionDto>>;
    public createPosition(id: string, body?: BillPositionUpsertDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling createPosition.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/positions`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteFilter(id: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public deleteFilter(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public deleteFilter(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public deleteFilter(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteFilter.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.delete(`${this.basePath}/api/bill/filters/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportHistory(id: string, observe?: 'body', reportProgress?: boolean): Promise<BillActivityExportDto>;
    public exportHistory(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillActivityExportDto>>;
    public exportHistory(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillActivityExportDto>>;
    public exportHistory(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportHistory.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/history/export`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public get(id: string, observe?: 'body', reportProgress?: boolean): Promise<BillDto>;
    public get(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDto>>;
    public get(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDto>>;
    public get(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling get.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getApproval(id: string, observe?: 'body', reportProgress?: boolean): Promise<BillApprovalDto>;
    public getApproval(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillApprovalDto>>;
    public getApproval(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillApprovalDto>>;
    public getApproval(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getApproval.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/approval`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDetail(id: string, observe?: 'body', reportProgress?: boolean): Promise<BillDetailBootstrapDto>;
    public getDetail(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDetailBootstrapDto>>;
    public getDetail(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDetailBootstrapDto>>;
    public getDetail(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDetail.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/detail`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDetailLayouts(observe?: 'body', reportProgress?: boolean): Promise<BillDetailLayoutCollectionDto>;
    public getDetailLayouts(observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDetailLayoutCollectionDto>>;
    public getDetailLayouts(observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDetailLayoutCollectionDto>>;
    public getDetailLayouts(observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/detail-layouts`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDocuments(id: string, observe?: 'body', reportProgress?: boolean): Promise<BillDocumentsDto>;
    public getDocuments(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDocumentsDto>>;
    public getDocuments(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDocumentsDto>>;
    public getDocuments(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDocuments.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/documents`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFilters(observe?: 'body', reportProgress?: boolean): Promise<Array<BillFilterDto>>;
    public getFilters(observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<Array<BillFilterDto>>>;
    public getFilters(observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<Array<BillFilterDto>>>;
    public getFilters(observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/filters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGridColumnState(observe?: 'body', reportProgress?: boolean): Promise<BillOverviewGridStateDto>;
    public getGridColumnState(observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillOverviewGridStateDto>>;
    public getGridColumnState(observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillOverviewGridStateDto>>;
    public getGridColumnState(observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/grid-column-state`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHistory(id: string, observe?: 'body', reportProgress?: boolean): Promise<Array<BillHistoryDto>>;
    public getHistory(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<Array<BillHistoryDto>>>;
    public getHistory(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<Array<BillHistoryDto>>>;
    public getHistory(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getHistory.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/history`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPaymentTerms(observe?: 'body', reportProgress?: boolean): Promise<Array<PaymentTermDto>>;
    public getPaymentTerms(observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<Array<PaymentTermDto>>>;
    public getPaymentTerms(observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<Array<PaymentTermDto>>>;
    public getPaymentTerms(observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/payment-terms`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param purchaseOrderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPurchaseOrderItemOptions(purchaseOrderId: string, observe?: 'body', reportProgress?: boolean): Promise<Array<PurchaseOrderItemDto>>;
    public getPurchaseOrderItemOptions(purchaseOrderId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<Array<PurchaseOrderItemDto>>>;
    public getPurchaseOrderItemOptions(purchaseOrderId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<Array<PurchaseOrderItemDto>>>;
    public getPurchaseOrderItemOptions(purchaseOrderId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (purchaseOrderId === null || purchaseOrderId === undefined) {
            throw new Error('Required parameter purchaseOrderId was null or undefined when calling getPurchaseOrderItemOptions.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/purchase-orders/${encodeURIComponent(String(purchaseOrderId))}/items`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param purchaseOrderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPurchaseOrderItems(id: string, purchaseOrderId: string, observe?: 'body', reportProgress?: boolean): Promise<BillPurchaseOrderItemsDto>;
    public getPurchaseOrderItems(id: string, purchaseOrderId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillPurchaseOrderItemsDto>>;
    public getPurchaseOrderItems(id: string, purchaseOrderId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillPurchaseOrderItemsDto>>;
    public getPurchaseOrderItems(id: string, purchaseOrderId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPurchaseOrderItems.');
        }
        if (purchaseOrderId === null || purchaseOrderId === undefined) {
            throw new Error('Required parameter purchaseOrderId was null or undefined when calling getPurchaseOrderItems.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/purchase-orders/${encodeURIComponent(String(purchaseOrderId))}/items`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reassign(id: string, body?: BillReassignDto, observe?: 'body', reportProgress?: boolean): Promise<BillDto>;
    public reassign(id: string, body?: BillReassignDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDto>>;
    public reassign(id: string, body?: BillReassignDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDto>>;
    public reassign(id: string, body?: BillReassignDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling reassign.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/reassign`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param fileId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeDocument(id: string, fileId: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public removeDocument(id: string, fileId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public removeDocument(id: string, fileId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public removeDocument(id: string, fileId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeDocument.');
        }
        if (fileId === null || fileId === undefined) {
            throw new Error('Required parameter fileId was null or undefined when calling removeDocument.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.delete(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/documents/${encodeURIComponent(String(fileId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reorderFilters(body?: BillFilterReorderDto, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public reorderFilters(body?: BillFilterReorderDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public reorderFilters(body?: BillFilterReorderDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public reorderFilters(body?: BillFilterReorderDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/bill/filters/reorder`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reorderPositions(id: string, body?: BillPositionReorderDto, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public reorderPositions(id: string, body?: BillPositionReorderDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public reorderPositions(id: string, body?: BillPositionReorderDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public reorderPositions(id: string, body?: BillPositionReorderDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling reorderPositions.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/positions/reorder`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public repeatVisa(id: string, observe?: 'body', reportProgress?: boolean): Promise<BillApprovalDto>;
    public repeatVisa(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillApprovalDto>>;
    public repeatVisa(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillApprovalDto>>;
    public repeatVisa(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling repeatVisa.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/repeat-visa`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param dryRun 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public replacePositions(id: string, body?: BillPositionsReplaceDto, dryRun?: boolean, observe?: 'body', reportProgress?: boolean): Promise<BillPositionsValidationDto>;
    public replacePositions(id: string, body?: BillPositionsReplaceDto, dryRun?: boolean, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillPositionsValidationDto>>;
    public replacePositions(id: string, body?: BillPositionsReplaceDto, dryRun?: boolean, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillPositionsValidationDto>>;
    public replacePositions(id: string, body?: BillPositionsReplaceDto, dryRun?: boolean, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling replacePositions.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (dryRun !== undefined && dryRun !== null) {
            queryParameters = queryParameters.set('dryRun', <any>dryRun);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/positions`,
            body,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetDetailLayouts(observe?: 'body', reportProgress?: boolean): Promise<any>;
    public resetDetailLayouts(observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public resetDetailLayouts(observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public resetDetailLayouts(observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.delete(`${this.basePath}/api/bill/detail-layouts`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveDetailLayouts(body?: BillDetailLayoutCollectionUpdateDto, observe?: 'body', reportProgress?: boolean): Promise<BillDetailLayoutCollectionDto>;
    public saveDetailLayouts(body?: BillDetailLayoutCollectionUpdateDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDetailLayoutCollectionDto>>;
    public saveDetailLayouts(body?: BillDetailLayoutCollectionUpdateDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDetailLayoutCollectionDto>>;
    public saveDetailLayouts(body?: BillDetailLayoutCollectionUpdateDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/bill/detail-layouts`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveGridColumnState(body?: BillOverviewGridStateDto, observe?: 'body', reportProgress?: boolean): Promise<BillOverviewGridStateDto>;
    public saveGridColumnState(body?: BillOverviewGridStateDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillOverviewGridStateDto>>;
    public saveGridColumnState(body?: BillOverviewGridStateDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillOverviewGridStateDto>>;
    public saveGridColumnState(body?: BillOverviewGridStateDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/bill/grid-column-state`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param gridType 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public savePositionGridState(gridType: BillPositionGridType, body?: UpdateBillPositionGridStateDto, observe?: 'body', reportProgress?: boolean): Promise<BillPositionGridStateDto>;
    public savePositionGridState(gridType: BillPositionGridType, body?: UpdateBillPositionGridStateDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillPositionGridStateDto>>;
    public savePositionGridState(gridType: BillPositionGridType, body?: UpdateBillPositionGridStateDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillPositionGridStateDto>>;
    public savePositionGridState(gridType: BillPositionGridType, body?: UpdateBillPositionGridStateDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (gridType === null || gridType === undefined) {
            throw new Error('Required parameter gridType was null or undefined when calling savePositionGridState.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/bill/position-grid-state/${encodeURIComponent(String(gridType))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public search(body?: BillSearchRequestDto, observe?: 'body', reportProgress?: boolean): Promise<BillSearchResponseDto>;
    public search(body?: BillSearchRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillSearchResponseDto>>;
    public search(body?: BillSearchRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillSearchResponseDto>>;
    public search(body?: BillSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/search`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchAnlagen(body?: BillAnlagenSearchRequestDto, observe?: 'body', reportProgress?: boolean): Promise<AnlagenSearchDtoSearchResponse>;
    public searchAnlagen(body?: BillAnlagenSearchRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<AnlagenSearchDtoSearchResponse>>;
    public searchAnlagen(body?: BillAnlagenSearchRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<AnlagenSearchDtoSearchResponse>>;
    public searchAnlagen(body?: BillAnlagenSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/anlage/search`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchCostCentres(body?: BillCostCentreSearchRequestDto, observe?: 'body', reportProgress?: boolean): Promise<CostCentreSearchDtoSearchResponse>;
    public searchCostCentres(body?: BillCostCentreSearchRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<CostCentreSearchDtoSearchResponse>>;
    public searchCostCentres(body?: BillCostCentreSearchRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<CostCentreSearchDtoSearchResponse>>;
    public searchCostCentres(body?: BillCostCentreSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/cost-centre/search`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchCustomers(body?: BillCustomerSearchRequestDto, observe?: 'body', reportProgress?: boolean): Promise<CustomerSearchDtoSearchResponse>;
    public searchCustomers(body?: BillCustomerSearchRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<CustomerSearchDtoSearchResponse>>;
    public searchCustomers(body?: BillCustomerSearchRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<CustomerSearchDtoSearchResponse>>;
    public searchCustomers(body?: BillCustomerSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/customer/search`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchFibuAccounts(body?: BillFibuAccountSearchRequestDto, observe?: 'body', reportProgress?: boolean): Promise<FibuAccountSearchDtoSearchResponse>;
    public searchFibuAccounts(body?: BillFibuAccountSearchRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<FibuAccountSearchDtoSearchResponse>>;
    public searchFibuAccounts(body?: BillFibuAccountSearchRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<FibuAccountSearchDtoSearchResponse>>;
    public searchFibuAccounts(body?: BillFibuAccountSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/fibu-account/search`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchProjects(body?: BillProjectSearchRequestDto, observe?: 'body', reportProgress?: boolean): Promise<ProjectSearchDtoSearchResponse>;
    public searchProjects(body?: BillProjectSearchRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<ProjectSearchDtoSearchResponse>>;
    public searchProjects(body?: BillProjectSearchRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<ProjectSearchDtoSearchResponse>>;
    public searchProjects(body?: BillProjectSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/project/search`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchPurchaseOrders(body?: BillPurchaseOrderSearchRequestDto, observe?: 'body', reportProgress?: boolean): Promise<PurchaseOrderOverviewDtoSearchResponse>;
    public searchPurchaseOrders(body?: BillPurchaseOrderSearchRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<PurchaseOrderOverviewDtoSearchResponse>>;
    public searchPurchaseOrders(body?: BillPurchaseOrderSearchRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<PurchaseOrderOverviewDtoSearchResponse>>;
    public searchPurchaseOrders(body?: BillPurchaseOrderSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/purchase-orders/search`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchSuppliers(id: string, body?: SupplierSearchRequestDto, observe?: 'body', reportProgress?: boolean): Promise<SupplierSearchDtoSearchResponse>;
    public searchSuppliers(id: string, body?: SupplierSearchRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SupplierSearchDtoSearchResponse>>;
    public searchSuppliers(id: string, body?: SupplierSearchRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SupplierSearchDtoSearchResponse>>;
    public searchSuppliers(id: string, body?: SupplierSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling searchSuppliers.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/supplier/search`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param targetTenant 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchTenantChangeSuppliers(id: string, targetTenant: number, body?: SupplierSearchRequestDto, observe?: 'body', reportProgress?: boolean): Promise<SupplierSearchDtoSearchResponse>;
    public searchTenantChangeSuppliers(id: string, targetTenant: number, body?: SupplierSearchRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SupplierSearchDtoSearchResponse>>;
    public searchTenantChangeSuppliers(id: string, targetTenant: number, body?: SupplierSearchRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SupplierSearchDtoSearchResponse>>;
    public searchTenantChangeSuppliers(id: string, targetTenant: number, body?: SupplierSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling searchTenantChangeSuppliers.');
        }
        if (targetTenant === null || targetTenant === undefined) {
            throw new Error('Required parameter targetTenant was null or undefined when calling searchTenantChangeSuppliers.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/tenant-change/${encodeURIComponent(String(targetTenant))}/supplier/search`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transmit(id: string, observe?: 'body', reportProgress?: boolean): Promise<BillDto>;
    public transmit(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDto>>;
    public transmit(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDto>>;
    public transmit(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling transmit.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/transmit`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transmitWithVisaOverride(id: string, observe?: 'body', reportProgress?: boolean): Promise<BillDto>;
    public transmitWithVisaOverride(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDto>>;
    public transmitWithVisaOverride(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDto>>;
    public transmitWithVisaOverride(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling transmitWithVisaOverride.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/transmit-with-visa-override`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCreditor(id: string, body?: BillCreditorUpdateDto, observe?: 'body', reportProgress?: boolean): Promise<BillDto>;
    public updateCreditor(id: string, body?: BillCreditorUpdateDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDto>>;
    public updateCreditor(id: string, body?: BillCreditorUpdateDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDto>>;
    public updateCreditor(id: string, body?: BillCreditorUpdateDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateCreditor.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/creditor`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFilter(body?: UpdateBillFilterRequestDto, observe?: 'body', reportProgress?: boolean): Promise<BillFilterDto>;
    public updateFilter(body?: UpdateBillFilterRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillFilterDto>>;
    public updateFilter(body?: UpdateBillFilterRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillFilterDto>>;
    public updateFilter(body?: UpdateBillFilterRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/bill/filters`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateHead(id: string, body?: BillHeadUpdateDto, observe?: 'body', reportProgress?: boolean): Promise<BillDto>;
    public updateHead(id: string, body?: BillHeadUpdateDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDto>>;
    public updateHead(id: string, body?: BillHeadUpdateDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDto>>;
    public updateHead(id: string, body?: BillHeadUpdateDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateHead.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/head`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param positionId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePosition(id: string, positionId: string, body?: BillPositionUpsertDto, observe?: 'body', reportProgress?: boolean): Promise<BillPositionDto>;
    public updatePosition(id: string, positionId: string, body?: BillPositionUpsertDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillPositionDto>>;
    public updatePosition(id: string, positionId: string, body?: BillPositionUpsertDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillPositionDto>>;
    public updatePosition(id: string, positionId: string, body?: BillPositionUpsertDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updatePosition.');
        }
        if (positionId === null || positionId === undefined) {
            throw new Error('Required parameter positionId was null or undefined when calling updatePosition.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/positions/${encodeURIComponent(String(positionId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateProcessType(id: string, body?: BillProcessTypeUpdateDto, observe?: 'body', reportProgress?: boolean): Promise<BillDto>;
    public updateProcessType(id: string, body?: BillProcessTypeUpdateDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<BillDto>>;
    public updateProcessType(id: string, body?: BillProcessTypeUpdateDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<BillDto>>;
    public updateProcessType(id: string, body?: BillProcessTypeUpdateDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateProcessType.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/bill/${encodeURIComponent(String(id))}/process-type`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

}
